'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_DebugDataPageMeta$() {
}
export { $c_Lapp_pages_DebugDataPageMeta$ as $c_Lapp_pages_DebugDataPageMeta$ };
$c_Lapp_pages_DebugDataPageMeta$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_DebugDataPageMeta$.prototype.constructor = $c_Lapp_pages_DebugDataPageMeta$;
/** @constructor */
function $h_Lapp_pages_DebugDataPageMeta$() {
}
export { $h_Lapp_pages_DebugDataPageMeta$ as $h_Lapp_pages_DebugDataPageMeta$ };
$h_Lapp_pages_DebugDataPageMeta$.prototype = $c_Lapp_pages_DebugDataPageMeta$.prototype;
$c_Lapp_pages_DebugDataPageMeta$.prototype.pageTitle__Lframework_localization_LocalizationSupport$LocalizedText = (function() {
  var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().LocalizedText__Lframework_localization_LocalizationSupport$LocalizedText$();
  var localize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "Debug Data";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$$anon$2(localize, this$1);
});
var $d_Lapp_pages_DebugDataPageMeta$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_DebugDataPageMeta$, "app.pages.DebugDataPageMeta$", ({
  Lapp_pages_DebugDataPageMeta$: 1
}));
export { $d_Lapp_pages_DebugDataPageMeta$ as $d_Lapp_pages_DebugDataPageMeta$ };
var $n_Lapp_pages_DebugDataPageMeta$;
function $m_Lapp_pages_DebugDataPageMeta$() {
  if ((!$n_Lapp_pages_DebugDataPageMeta$)) {
    $n_Lapp_pages_DebugDataPageMeta$ = new $c_Lapp_pages_DebugDataPageMeta$();
  }
  return $n_Lapp_pages_DebugDataPageMeta$;
}
export { $m_Lapp_pages_DebugDataPageMeta$ as $m_Lapp_pages_DebugDataPageMeta$ };
//# sourceMappingURL=app.pages.-Debug-Data-Page-Meta$.js.map
